export const TARIFF_IDS_WITH_PLAY_TIME_LIMIT = [1];

export const TARIFF_IDS_WITH_HOMEWORK_LIMIT = [1];

export const TARIFF_IDS_WITH_BONUS_GAMES_HIDED = [1];

export const TARIFF_IDS_WITH_GENERATOR_DISABLED = [1];

export const PLAYTIME_TARIFF_RESTRICTION_APPLIES_TO_USER_TYPES = ['student', 'teacher'];

export const DEFAULT_PLAYTIME_LIMIT = 900;

/** How often an active game reports spent playtime to the server. */
export const PLAYTIME_SYNC_INTERVAL_MS = 3 * 60 * 1000;

export const ROUTES_UNDER_PLAY_TIME_RESTRICTION = ['trainer:games', 'game:edit', 'create:game'];

export const RESTRICTED_ADMIN_ROUTES = ['trainer:games', 'browse:game', 'game:edit', 'create:game', 'trainer:main'];

export const TEMPLATE_ROUTES_HIDDEN_FOR_FREE_TARIFF_TEACHER = ['homework-template:list', 'lesson-conducting-template:list'];
